import { render } from "./PokemonList.vue?vue&type=template&id=bdc05608&scoped=true"
import script from "./PokemonList.vue?vue&type=script&lang=js"
export * from "./PokemonList.vue?vue&type=script&lang=js"

import "./PokemonList.vue?vue&type=style&index=0&id=bdc05608&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bdc05608"

export default script